import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PageNotFound from "./components/CommanComponents/PageNotFound";
import PrivateRoute from "./components/CommanComponents/securedRoutes";
import { appRoutes, privateRoutes } from "./constants/routes";




class App extends Component {
 
  render() {
    return (
            <Router>
              <Switch>
                {appRoutes.map((routeProps, index) => (
                  <Route key={index} {...routeProps} />
                ))}
                {privateRoutes.map((routeProps, index) => {
                  return <PrivateRoute key={index} {...routeProps} />;
                })}
                <Route component={PageNotFound} />
              </Switch>
            </Router>
    );
  }
}
export default withTranslation()(App);

